import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  CircularProgress,
  createStyles,
  Grid,
  makeStyles,
} from '@material-ui/core';

// Data Layer
import { useNetworkObserver } from 'data-layer-cr/dist/network';

// Redux
import { parse } from 'query-string';
import {
  loginExternalByHash,
  loginExternalByToken,
} from '../../../../store/profile/actions';

// Network
import { LOGIN } from '../../../../store/profile/requestIdentifiers';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      height: 'calc(100vh)',
      backgroundImage: 'url("../svg/login_background.svg")',
      backgroundSize: '100% auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        backgroundImage: 'none',
        backgroundSize: '100%',
      },
    },
    logoImage: {
      marginBottom: theme.spacing(2),
    },
    leftLogo: {
      position: 'fixed',
      left: 0,
      top: '25%',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    topLogo: {
      position: 'fixed',
      top: 0,
      left: '60%',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    bottomRightLogo: {
      position: 'fixed',
      bottom: 0,
      right: 0,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }),
);

export const ExternalLoginScreen = ({
  requestLoginHashAction,
  requestLoginTokenAction,
}: PropsFromRedux): JSX.Element => {
  const classes = useStyles();
  const history = useNavigate();

  const location = useLocation();
  const values = parse(location.search);
  const hash = values.hash?.toString() || '';
  const token = values.token?.toString() || '';

  const loginRequestStatus = useNetworkObserver(LOGIN);

  useEffect(() => {
    if (loginRequestStatus === 'success') {
      history('/');
    }
  }, [loginRequestStatus, history, hash]);

  useEffect(() => {
    if (token !== '') {
      requestLoginTokenAction(token);
    }
  }, [token, requestLoginTokenAction]);

  useEffect(() => {
    if (hash !== '') {
      requestLoginHashAction(hash);
    }
  }, [hash, requestLoginHashAction]);

  return (
    <div className={classes.container}>
      <img
        className={classes.topLogo}
        src="/svg/login_top_artifact.svg"
        alt="top-artifact"
      />
      <img
        className={classes.leftLogo}
        src="/svg/login_left_artifact.svg"
        alt="left-artifact"
      />
      <img
        className={classes.bottomRightLogo}
        src="/svg/login_bottom_right_artifact.svg"
        alt="bottom-right-artifact"
      />
      <Grid container spacing={3}>
        <Grid item xs container alignItems="center" justifyContent="center">
          <img
            className={classes.logoImage}
            src="../svg/assa_logo.svg"
            width={230}
            alt="Logo"
          />
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <div>
            {loginRequestStatus === 'requesting' && (
              <CircularProgress size={50} data-testid="login-progress" />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

const reduxActions = {
  requestLoginHashAction: loginExternalByHash,
  requestLoginTokenAction: loginExternalByToken,
};
const connector = connect(null, reduxActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ExternalLoginScreen);
